import app from './js/app';
import i18n from './js/i18n';
import router from './js/router';
import settings from './js/settings';
import token from './js/token';

app.lib.i18n = i18n;
app.lib.router = router;
app.lib.settings = settings;
app.lib.token = token;

app.fn.run();
